import { useEffect } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { getUser, setUser, removeUser } from "@/hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";

const AuthHandler = () => {
  const navigate = useNavigate();

  const setUserData = async (userId) => {
    try {
      const docRef = doc(db, "users", userId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setUser({
          uid: userId,
          name: data.first_name,
          role: data.roles[0],
          allowedRoles: data.roles,
        });
      }
    } catch (error) {
      console.error("Error getting user data:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        // Email verify
        if (!user.emailVerified) {
          console.log("Email not verified");
          navigate("/verify");
          return;
        }

        // Remove
        if (localStorage.getItem("lastEmailSent")) {
          localStorage.removeItem("lastEmailSent");
        }

        // User info exists
        if (getUser()) {
          return;
        }

        // Save user info
        await setUserData(user.uid);
        navigate("/home");
      } else {
        removeUser();
      }
    });

    return () => unsubscribe();
  }, []);

  return null;
};

export default AuthHandler;
